"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * A react hook to watch for dependency changes, but ignoring the first render (unlike useEffect).
 * This is a bit naive and will fail when development builds render a component twice.
 * 
 * @param {*} callback The function to be the effect's logic
 * @param {Array} dependencies A list of useEffect dependencies
 */
const useUpdated = (callback, dependencies) => {
  const componentIsMounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (componentIsMounted.current) return callback?.();else componentIsMounted.current = true;
    return null;
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps
};
var _default = exports.default = useUpdated;